import type {BoxProps} from '@chakra-ui/react';
import {Box, Container, Flex} from '@chakra-ui/react';
import type {FC} from 'react';

import {useNavbarStyleConfig} from '../../theme-config';

type Props = BoxProps;

const NavbarContainer: FC<Props> = ({children, ...propsWithoutChildren}) => {
  const style = useNavbarStyleConfig(`container`);
  return (
    <Box as={`section`}>
      <Box as={`nav`} width={`100%`} {...style} {...propsWithoutChildren}>
        <Container py={{base: `3`, lg: `4`}} maxW={`unset`}>
          <Flex justify={`space-between`} gap={`8`}>
            {children}
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};

export default NavbarContainer;
export type {Props as NavbarContainerProps};
